import CommonCss from "lib/common/style.module.scss";

import { AutoTooltip } from "lib/common";
import { FiCopy, FiFileText } from "react-icons/fi";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import React from "react";

const DocumentIdCell = ({ id, value, status, duplicatedDocumentsIds, attachmentKey }) => {
  const extractionStatus = status === DataStatuses.TO_EXTRACT;

  const hasDuplicates = !!(Array.isArray(duplicatedDocumentsIds) && duplicatedDocumentsIds.length);

  return (
    <AutoTooltip active={!!(!extractionStatus && value)}>
      <span data-id={id}>
        {extractionStatus
          ? Constants.EMPTY_PLACEHOLDER
          : <>
            {hasDuplicates
              ? <FiCopy className={CommonCss.warningText} />
              : <FiFileText className={attachmentKey ? "" : CommonCss.negativeText} />}
            {!!value && <span>{value}</span>}
          </>}
      </span>
    </AutoTooltip>
  );
};

export default React.memo(DocumentIdCell);
